<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="detail_dialog" top="7vh" width="1100px" :fullscreen="isExpand"
    :show-close="false" :before-close="handleClose" :close-on-click-modal="false" :append-to-body="true" :close-on-press-escape="false">
    <template slot="title">
      <div class="default-dialog-title-box">
        <span>选择适配设备</span>
        <span class="icon-box">
          <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
          <i class="el-icon-close" @click="handleClose"></i>
        </span>
      </div>
    </template>
    <div class="content">
      <span class="device-title">适配设备</span>
      <el-radio-group v-model="deviceType">
        <el-radio label="1">固定设备</el-radio>
        <el-radio label="2">通用</el-radio>
      </el-radio-group>
      <template v-if="deviceType === '1'">
        <div class="c_group">
          <query-form size="small" label-width="30px" @search="handleSearch" @reset='handleReset' :defaultCollapsed="false" class="content_block">
            <el-form-item label-width="0px">
              <el-input v-model.trim="form.name" clearable placeholder="请输入设备名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model.trim="form.model" clearable placeholder="请输入设备型号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model.trim="form.enterpriseName" clearable placeholder="请输入生产厂家"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model.trim="form.brandName" clearable placeholder="请输入品牌"></el-input>
            </el-form-item>
          </query-form>
        </div>
        <xz-table
          ref="xzTable"
          :columns="columnList"
          :data="dataList"
          :enableRowSelection="true"
          :scroll="{ x: '100%', y: scrollHeight }"
          rowKey="id"
          selectionType="checkbox"
          :selectedRowKeys="selectedKeys"
          @change="handleSelectionChange"
          @refresh="handleReset">
        </xz-table>
        <div class="pagination-wrapper">
          <a-pagination
            :current="page.pageNum"
            :total="total"
            :show-total="total => `共 ${total} 条`"
            show-size-changer
            :pageSizeOptions="['10', '20', '30', '50', '100']"
            show-quick-jumper
            :pageSize.sync="page.pageSize"
            @change="handleNumChange"
            @showSizeChange="handleSizeChange"
          />
        </div>
        <div class="selected-tip">已选择设备</div>
        <xz-table
          ref="xzTableSelected"
          :columns="columnList"
          :data="selectedLists"
          rowKey="id"
          :scroll="{ x: '100%' }">
        </xz-table>
      </template>
    </div>
    <div class="dialog-footer" style="padding-top: 10px; text-align: right;">
      <el-button plain @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSure" :disabled="!selectedKeys.length && deviceType !== '2'">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getDevicePageList, getDevicePageList1xie } from '@/api/goods';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';

const COMMON_COLUMNS = [
  {
    title: '设备名称',
    dataIndex: 'name',
    key: 'name',
    width: 180,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '设备型号',
    dataIndex: 'model',
    key: 'model',
    width: 100,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '生产厂商',
    dataIndex: 'enterpriseName',
    key: 'enterpriseName',
    width: 160,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '设备品牌',
    dataIndex: 'brandName',
    key: 'brandName',
    width: 160,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '设备类目',
    dataIndex: 'categoryAllName',
    key: 'categoryAllName',
    width: 300,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '注册证号',
    dataIndex: 'registerCode',
    key: 'registerCode',
    width: 180,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
];

export default {
  components: {
    xzTable,
  },
  props: {
    useXieApi: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      deviceType: '1',
      dialogVisible: false,
      isExpand: false,
      expandSvg: require('@/assets/ic_expand.svg'),
      collapseSvg: require('@/assets/ic_collapse.svg'),
      form: {
        name: '',
        model: '',
        brandName: '',
        enterpriseName: '',
      },
      selectedKeys: [],
      selectedLists: [],
      total: 0,
      dataList: [],
      columnList: [
        ...COMMON_COLUMNS,
      ],
      scrollHeight: 260,
      page: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  watch: {
    dialogVisible (v) {
      if (v) {
        this.handleSearch();
      } else {
        this.form = this.$options.data().form;
        this.selectedKeys = this.$options.data().selectedKeys;
        this.selectedLists = this.$options.data().selectedLists;
      }
    },
  },
  methods: {
    handleClose () {
      this.dialogVisible = false;
    },
    handleSelectionChange (keys, rows) {
      // 移除
      if (this.selectedKeys.length > keys.length) {
        const diff = this.selectedKeys.filter(item => !keys.includes(item));
        this.selectedLists = this.selectedLists.filter(item => !diff.includes(item.id));
      }
      // 增加
      if (this.selectedKeys.length < keys.length) {
        const diff = keys.filter(item => !this.selectedKeys.includes(item));
        const list = rows.filter(item => diff.includes(item.id));
        this.selectedLists = [...this.selectedLists, ...list];
      }
      this.selectedKeys = keys;
    },
    handleSure () {
      this.$emit('saveDevice', { deviceType: this.deviceType, selectedLists: this.selectedLists });
      this.dialogVisible = false;
    },
    handleSizeChange (_, size) {
      this.page.pageSize = size;
      this.queryList();
    },
    handleNumChange (num) {
      this.page.pageNum = num;
      this.queryList();
    },
    handleReset () {
      this.form = this.$options.data().form;
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      this.queryList();
    },
    handleSearch () {
      this.page.pageNum = 1;
      this.queryList();
    },
    async queryList () {
      if (this.useXieApi) {
        const params = {
          ...this.form,
          pageNumber: this.page.pageNum,
          pageSize: this.page.pageSize,
          findCategoryAllNameFlag: true,
        };
        const { body } = await getDevicePageList1xie(params);
        this.total = +body.total || 0;
        this.dataList = body.records || [];
      } else {
        const params = {
          ...this.form,
          ...this.page,
          findCategoryAllNameFlag: true,
        };
        const { body } = await getDevicePageList(params);
        this.total = +body.total || 0;
        this.dataList = body.list || [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.detail_dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
  }

  .content {
    padding: 0 10px;
    .device-title {
      padding: 0 15px;
      &::before {
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
      }
    }

    .c_group {
      padding-top: 10px;
      position: relative;
      .content_block {
        padding: 10px;
      }
    }

    .selected-tip {
      font-size: 15px;
      font-weight: bold;
      color: #1F2733;
      padding-top: 10px;
    }
  }
}
</style>
